var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.715V30.285C39 30.375 39 30.465 38.985 30.54C38.985 31.35 38.895 32.1 38.73 32.79C38.025 36.03 35.865 38.13 32.58 38.775C31.875 38.925 31.125 39 30.33 39H17.58C16.785 38.985 16.035 38.91 15.33 38.76C12.105 38.1 9.975 36 9.27 32.79C9.105 32.1 9.015 31.35 9.015 30.54C9 30.465 9 30.375 9 30.285V17.715C9 16.95 9.06 16.215 9.195 15.54C9.825 12.15 12 9.93 15.33 9.24C16.035 9.075 16.785 9 17.58 9H30.345C31.14 9 31.89 9.075 32.58 9.225C35.97 9.885 38.175 12.12 38.805 15.54C38.94 16.215 39 16.95 39 17.715Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 17.79V30.54H38.985C38.985 31.35 38.895 32.1 38.73 32.79H32.58V38.775C31.875 38.925 31.125 39 30.33 39V32.79H25.125V39H22.875V32.79H17.58V39C16.785 38.985 16.035 38.91 15.33 38.76V32.79H9.27C9.105 32.1 9.015 31.35 9.015 30.54H22.875V17.79H9V17.715C9 16.95 9.06 16.215 9.195 15.54H15.36C15.345 15.48 15.33 15.42 15.33 15.36V9.24C16.035 9.075 16.785 9 17.58 9V15.36C17.58 15.42 17.55 15.48 17.535 15.54H22.875V9H25.125V15.54H30.33V9H30.345C31.14 9 31.89 9.075 32.58 9.225V15.495C32.58 15.51 32.565 15.525 32.565 15.54H38.805C38.94 16.215 39 16.95 39 17.715V17.79H25.125Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoHorizontal);
export default __webpack_public_path__ + "static/media/videoHorizontal.08ebdd0cf3279fec8223741fa85fd575.svg";
export { ForwardRef as ReactComponent };